import { Component } from 'react';
import DataTable from '../../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { COLUMNS } from './keys';
import { withTranslation } from 'react-i18next';
import Loading from '../../../../../components/Loading';

class BrandEntities extends Component {
    constructor() {
        super();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            item?.brand_name?.toLowerCase()?.includes(search.toLowerCase()),
        );
    }

    render() {
        const { t } = this.props;
        if (this.props.loading) {
            return <Loading />;
        }

        const items = this.props.items.map((item) => ({
            ...item,
            topics: [
                {
                    name: item?.name,
                    prompts: item?.generated_prompts?.map((item) => item.text),
                },
            ],
        }));

        return (
            <div className="card">
                <DataTable
                    nodes={items}
                    sortFns={getSortKeys(COLUMNS(t))}
                    COLUMNS={COLUMNS(t)}
                    fileName={t('ai_tracking.prompt_history.brands.header')}
                    header={t('ai_tracking.prompt_history.brands.header')}
                    searchFunction={this.searchFunction}
                    customEmptyMessage={t('global.no_data')}
                    uniqKey={'id'}
                    additionalStyles={setAdditionalStyles(COLUMNS(t))}
                />
            </div>
        );
    }
}

export default withTranslation()(BrandEntities);
